import qs from "qs";
import Vue from "vue";
import { uploadImgBase } from "../libs/constant/constant.js";
import { previewImgBase } from "../libs/constant/constant.js";
import { baiduUpload } from "../libs/constant/constant.js";
import mp4box from "mp4box";
export let uploadVideoImg = {
  data() {
    return {
      surplusSpace: 0, //剩余容量
      percentage: 0, //进度条
      isImg: false, //图片可传 false   不可传 true
      isVideo: false, //视频可传 false   不可传 true
      isPro: true, //展示进度条
      isload: false, //展示结果
      fileKeyList: [],
      videoKeyList: [],
      cover: "", //封面
      isUp: false,
      is_transcode: 0, //编码
      time: 0,
      source: null,
      url: "",
      partSize: 50 * 1024 * 1024, //分片大小
      client: "",
      p: 0,
      filename: "",
      maxSize: 1024 * 50, //视频最大5G
      directory: "customer/video/", //存储路径
      isWatermark: false, // 是否加水印
    };
  },
  computed: {},
  methods: {
    handleExceedVideo(files, fileList) {
      this.$message.warning(
        // `当前限制选择 5 张图片，本次选择了 ${
        //   files.length
        // } 张图片，共选择了 ${files.length + fileList.length} 张图片`
        "最多上传1个视频"
      );
    },
    format(percentage) {
      return "";
    },
    // 判断编码
    mp4box(file) {
      // var input  = document.getElementById("file"); // 获取上传的文件input.onchange = function() {
      // var file = this.files[0];
      var mp4boxFile = mp4box.createFile();
      mp4boxFile.onReady = function (info) {
        let mime = info.mime;
        let codec = mime.split('codecs="')[1];
        if (codec.indexOf("avc") === -1) {
          _this
            .axios({
              method: "post",
              url: `/service-file-app/app/file/encode?id=${data.id}`,
            })
            .then((res) => { });
          // this.is_transcode = 1;  // 需要转码    }    // 进行文件上传操作    ...
        } else {
          // this.is_transcode = 0
        }
      };

      if (file) {
        // 读取mp4的buffer
        var reader = new FileReader();
        var buffer = reader.readAsArrayBuffer(file);
        reader.onload = function (e) {
          var arrayBuffer = e.target.result;
          arrayBuffer.fileStart = 0;
          mp4boxFile.appendBuffer(arrayBuffer);
        };
      }
    },

    randomWord() {
      var str = "",
        range = 10,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ];

      // 随机产生
      for (var i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    },

    // 上传视频
    httpUploadVideo(res) {
      let axios = this.axios;
      let _this = this;
      _this.percentage = 0;
      if (_this.tx) {
        _this.tx.videoFlag = true;
      }

      // _this.mp4box(res.file)
      // console.log(_this.is_transcode)
      // if(_this.is_transcode == 1){
      //   _this.$message.warning("视频编码不符不能上传 ！");
      //   return
      // }

      // if (ext == 'mp4') { // 获取视频时长
      var urls = URL.createObjectURL(res.file);
      var audioElement = new Audio(urls);
      // var duration = 0;
      // var ele = this.$refs.dur
      audioElement.addEventListener("loadedmetadata", function (_event) {
        _this.time = parseInt(audioElement.duration); //时长为秒，小数，182.36
        // ele.name = duration //目前使用这种方式解决js与vue之间的传值问题
        // _this.$parent.$data.wDuration = parseInt(duration) //注意传递给接口的时长字段类型要与接口接收的字段类型一致，不然无法获取到值

        // if(res.file.size > _this.surplusSpace){
        //   _this.$message.warning("剩余空间不足，请先购买空间扩容 ！");
        //   return
        // }

        let file = res.file;
        let type = file.type.split("/");
        // _this.filename =  Math.random().toString(36).substr(2) + '.' + type[1]
        _this.filename = _this.randomWord() + "." + type[1];
        // console.log(_this.filename)
        _this.isload = true;

        const progress = (p, _checkpoint) => {
          _this.percentage = parseInt(p * 100);
          if (_this.percentage == 100) {
            _this.isPro = false;
          }
          console.log(111111, _this.percentage); // Object的上传进度。
          // console.log(_checkpoint); // 分片上传的断点信息。
        };

        // let objectname = _this.filename
        let objectname = "/cms/" + _this.filename;
        // console.log(objectname)

        // 开始分片上传。
        async function multipartUpload() {
          try {
            _this.isUp = true;
            // object-name可以定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至Bucket根目录或Bucket下的指定目录。
            const result = await _this.client.multipartUpload(
              objectname,
              file,
              {
                progress,
                partSize: _this.partSize,
                // mime: 'mp4',
                // parallel: 10,
                headers: {
                  "Cache-Control": "public",
                  "Content-Disposition": "inline",
                  "Content-Type": "mp4",
                },
                meta: {
                  year: 2021,
                  people: "test",
                },
              }
            );
            console.log(result);
            // console.log(result.res.requestUrls)
            // const head = await _this.client.head(objectname)
            // console.log(head)

            _this.getUrl(file, result);
          } catch (e) {
            // 捕获超时异常。
            if (e.code === "ConnectionTimeoutError") {
              console.log("TimeoutError");
              // do ConnectionTimeoutError operation
              _this.videoKeyList = []
              _this.percentage = 0
              _this.isPro = false
              if (_this.tx.videoFlag) {
                _this.tx.videoFlag = false
              }
              _this.$message.error("请求时间超时，请重新上传")
            }
            console.log(e);
          }
        }
        if (file.size > 800 * 1024 * 1024) {
          multipartUpload();
        } else {
          axios({
            method: "post",
            url: "/service-file-app/app/file/get-ali-signature",
            interface: 1,
            // data: {formData},
            data: {
              filetype: type[1],
              originalFilename: file.name,
              directory: _this.directory,
              duration: _this.time,
            },
          }).then((res) => {
            let data = res.data;
            if (data.code == 0) {
              _this.isUp = true
              _this.url = data.data.host
              _this.getUrls(data.data, file)
            }
          });
        }
      });
    },
    getUrl(file, res) {
      let type = file.type.split("/");
      let urls = res.res.requestUrls[0].split("?");
      let keys = urls[0].split(".com/");
      let url = res.res.requestUrls[0].split("uploadId=");
      let key = url[1];
      // console.log(type[1])
      this.axios({
        url: "/service-file-app/app/file/add",
        method: "post",
        data: {
          directory: "/cms/",
          filename: this.filename,
          filepath: "cms/" + this.filename,
          filetype: type[1],
          key: "cms/" + this.filename,
          name: this.filename,
          originalFilename: file.name,
          size: parseInt(file.size / 1024),
          transcoder: this.is_transcode == 1 ? "true" : "false",
        },
      }).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          if (this.videoKeyList) {
            this.videoKeyList = [];
          }
          this.videoKeyList.push(data.data);
          this.cover = data.data.url + '?x-oss-process=video/snapshot,t_1,f_jpg,w_266,h_150,m_fast,ar_auto'
          this.isImg = true
          if (this.tx) {
            this.tx.videoFlag = false;
          }
          this.isPro = false
        } else {
          _this.$message.error("上传失败，请重新上传")
          _this.videoKeyList = []
          _this.percentage = 0
          _this.isPro = false
          if (_this.tx.videoFlag) {
            _this.tx.videoFlag = false
          }

        }
      });
    },

    getUrls(data1, file) {
      let _this = this;

      let formData = new FormData();
      formData.append("key", data1.key);
      formData.append("OSSAccessKeyId", data1.accessid);
      formData.append("callback", data1.callback);
      formData.append("dir", data1.dir);
      formData.append("expire", data1.expire);
      formData.append("policy", data1.policy);
      formData.append("signature", data1.signature);
      formData.append("file", file);

      const CancelToken = this.axios.CancelToken;
      _this.source = CancelToken.source();
      this.axios({
        url: this.url,
        data: formData,
        method: "post",
        cancelToken: _this.source.token,
        headers: {
          "Content-Type": "multipart/form-data",
        },

        onUploadProgress: (progressEvent) => {
          let complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          _this.percentage = complete;
          if (_this.percentage % 10 == 0) {
            // console.log(_this.percentage)
            // console.log('percentage')
          }
          if (_this.percentage == 100) {
            _this.isPro = false
          }
        },
      }).then((res) => {
        if (!res) return;
        let data = res.data;
        if (data.code == 0) {
          if (_this.videoKeyList) {
            _this.videoKeyList = [];
          }
          _this
            .axios({
              method: "post",
              url: `/service-file-app/app/file/encode?id=${data.data.id}&isWatermark=${_this.isWatermark}`,
            })
            .then((res) => { });
          _this.videoKeyList.push(data.data);
          _this.cover =
            data.data.url +
            "?x-oss-process=video/snapshot,t_1,f_jpg,w_266,h_150,m_fast,ar_auto";
          // console.log(_this.cover)
          // console.log(_this.videoKeyList)
          _this.isImg = true
          if (_this.tx) {
            _this.tx.videoFlag = false;
          }

        }
      });
    },

    delVideo() {
      this.videoKeyList = [];
      this.cover = "";
      this.isImg = false;
      this.isVideo = false;
      this.isload = false;
      this.percentage = 0;
      this.isPro = true;
    },

    beforeUploadVideo(file) {
      // 常见视频格式ogg: 'video/ogg' mp4: 'video/mp4' webm: 'video/webm' hls: 'application/x-mpegURL'
      const isJPG =
        file.type === "video/mp4" ||
        file.type === "video/ogg" ||
        file.type === "video/webm" ||
        file.type === "application/x-mpegURL";
      const isLt2M = file.size / 1024 / 1024 < this.maxSize;

      if (!isJPG) {
        this.$message.warning("只能上传视频格式!");
      }
      if (!isLt2M) {
        this.$message.warning(`上传视频大小不能超过 ${this.maxSize}G !`);
      }
      return isJPG && isLt2M;
    },

    getOss() {
      const OSS = require("ali-oss");
      const baseUrl = window.baseGate;

      let accessKeyId = baseUrl.accessKeyId;
      let accessKeySecret = baseUrl.accessKeySecret;
      let bucket = baseUrl.bucket;
      // if (
      //   process.env.NODE_ENV == "development" ||
      //   process.env.NODE_ENV == "env"
      // ) {
      //   // (accessKeyId = "LTAI4GDadFZy3FUgV68kFgLe"),
      //   //   (accessKeySecret = "ZXlEQKSHoOyPCl12j905Meb85SEGi9"),
      //   //   (bucket = "devrepos");
      //   accessKeyId = "LTAI4GJnP2MpHxgSNmNKQZFP";
      //   accessKeySecret = "OmpmoJ7wZrfJFO1FoxiavYPhoNsIXd";
      //   bucket = "testrepos";
      // }
      // if (process.env.NODE_ENV == "testing") {
      //   accessKeyId = "LTAI4GJnP2MpHxgSNmNKQZFP";
      //   accessKeySecret = "OmpmoJ7wZrfJFO1FoxiavYPhoNsIXd";
      //   bucket = "testrepos";
      // }
      // if (process.env.NODE_ENV == "production") {
      //   accessKeyId = "LTAI4G8y8WkiBWgpraGWRqyU";
      //   accessKeySecret = "zzwr2DUQEH4RPwoC38zYjvwh5iGtcX";
      //   bucket = "prodrepos";
      // }

      this.client = new OSS({
        // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
        region: "oss-cn-hangzhou",
        // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM用户进行API访问或日常运维，请登录RAM控制台创建RAM用户。
        accessKeyId,
        accessKeySecret,
        bucket,
        // secure: true //上传返回链接支持https
      });
    },
  },
  created() {
    this.getOss();
  },
};
